const removeBaseUrl = (url, baseUrl) => {
  const normalizedBase = baseUrl.replace(/\/+$/, "");
  return url.startsWith(normalizedBase) ? url.replace(normalizedBase, "") : url;
};
export {
  removeBaseUrl
};
//# sourceMappingURL=remove-base-url.js.map
